/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountdangerbutton2Inputs */

const en_accountdangerbutton2 = /** @type {(inputs: Accountdangerbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause and request deletion`)
};

const pt_accountdangerbutton2 = /** @type {(inputs: Accountdangerbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspender e pedir eliminação`)
};

/**
* | output |
* | --- |
* | "Pause and request deletion" |
*
* @param {Accountdangerbutton2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const accountdangerbutton2 = /** @type {((inputs?: Accountdangerbutton2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountdangerbutton2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountdangerbutton2(inputs)
	return pt_accountdangerbutton2(inputs)
});
export { accountdangerbutton2 as "accountDangerButton" }